import { render, staticRenderFns } from "./MarketplaceView.vue?vue&type=template&id=8a714010"
import script from "./MarketplaceView.vue?vue&type=script&lang=js"
export * from "./MarketplaceView.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceView.vue?vue&type=style&index=0&id=8a714010&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports